import { useEffect, useState } from "react";
import { MdNotes } from "react-icons/md";
import { useAccount, useDisconnect } from "wagmi";
import { NavWrapper, StyledLogo } from "./Header.style";
import MobileMenu from "./mobileMenu/MobileMenu";
import Button from "../../../common/button";
import { ConnectButton } from "../../common/ConnectButton";

const Header = ({variant}) => {
  const { isConnected } = useAccount();
  const { disconnect } = useDisconnect();
  const [isMobileMenu, setMobileMenu] = useState(false);
  let headerStyles;

  switch (variant) {
    case "homev2":
      headerStyles = "#efb90b";
      break;
    case "homev3":
      headerStyles = "#773ddd";
      break;
    default:
      headerStyles = "#0052ff";
  }
  const handleMobileMenu = () => {
    setMobileMenu(!isMobileMenu);
  };

  useEffect(() => {
    const header = document.getElementById("navbar");
    const handleScroll = window.addEventListener("scroll", () => {
      if (window.pageYOffset > 50) {
        header.classList.add("sticky");
      } else {
        header.classList.remove("sticky");
      }
    });

    return () => {
      window.removeEventListener("sticky", handleScroll);
    };
  }, []);

  return (
    <NavWrapper className="hermes_header" id="navbar">
      <div className="container">
        <div className="hermes_menu_sect">
          <div className="hermes_menu_left_sect">
            <div className="logo">
              <a href="/">
                <StyledLogo variant={headerStyles} />
              </a>
            </div>
          </div>
          <div className="hermes_menu_right_sect hermes_v1_menu_right_sect">
            <div className="hermes_menu_list">
              <ul>
                <li className="submenu">
                  <a href="# ">Home +</a>
                  <div className="sub_menu_sect">
                    <ul className="sub_menu_list">
                      <li>
                        <a href="/">Home One</a>
                      </li>
                      <li>
                        <a href="/home-two">Home Two</a>
                      </li>
                      <li>
                        <a href="/home-three">Home Three</a>
                      </li>
                    </ul>
                  </div>
                </li>

                <li>
                  <a href="#about">About</a>
                </li>
                <li>
                  <a href="#roadmap">Roadmap</a>
                </li>
                <li>
                  <a href="#team">Team</a>
                </li>
                <li>
                  <a href="#faq">FAQ</a>
                </li>
              </ul>
            </div>
            <div className="hermes_menu_btns">
              <button className="menu_btn" onClick={() => handleMobileMenu()}>
                <MdNotes />
              </button>
              {isConnected ? (
                <Button
                  sm
                  variant="hovered"
                  className="connect_btn"
                  onClick={() => disconnect()}
                >
                  Disconnect
                </Button>
              ) : (
                <ConnectButton />
              )}
            </div>
          </div>
        </div>
        {/* <!-- Main Menu END --> */}
        {isMobileMenu && (
          <MobileMenu mobileMenuhandle={handleMobileMenu} headerStyles={headerStyles}/>
        )}
      </div>
    </NavWrapper>
  );
};

export default Header;
